/* eslint-disable */
export default {
  log: 'Log',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
